<template>
  <div>
    <router-view v-if="showNestedChildRoute"></router-view>
    <div v-if="!haveNestedChildRoute && initialized">
      <CRow class="align-items-center mb-3" v-if="market.id">
        <CCol col="auto" class="mt-2 mb-1 my-sm-0">
          <CButton color="outline-primary" size="sm" @click="onBack()">
            <font-awesome-icon icon="arrow-left" />
          </CButton>
        </CCol>
        <CCol col="auto" class="mt-2 mb-1 my-sm-0">
          <figure v-if="marketHaveLogo(market)" class="m-0 mr-3">
            <img
              :src="marketLogoThumb(market)"
              alt=""
              class="border-0 rounded-circle"
              width="64"
              height="64"
            />
          </figure>
        </CCol>
        <CCol sm>
          <div class="ui-type-display-lg">
            {{ marketName(market) }}
          </div>
          <div v-html="market.market.role.desc_short"></div>
          <div>
            <span class="mr-1"
              >{{ $t("family.market.showcase.time_limit") }}
              <strong>{{ timelimitToOrder(market, $i18n.locale) }}</strong>
            </span>
            <span v-if="showDelivery(market)" class="mr-1"
              >| {{ $t("family.market.showcase.delivery") }}
              <strong>{{ deliveryDate(market) }}</strong></span
            >
            <span v-if="showPickup(market)" class="mr-1"
              >| {{ $t("family.market.showcase.pickup") }}
              <strong>{{ pickupDate(market) }}</strong></span
            >
            <a
              href="#0"
              v-if="showPickup(market)"
              @click.prevent="showMarketDeliveryMap = true"
              >{{ $t("family.market.showcase.pickup_list") }}</a
            >
          </div>

          <MarketDeliveryMapModal
            v-if="showMarketDeliveryMap"
            :show.sync="showMarketDeliveryMap"
            :market="market.market"
            :familyId="familyId"
            :title="`${marketName(market)} - Punti di ritiro`"
          />
        </CCol>
        <CCol col="auto" class="ml-auto text-right">
          <div
            class="ui-type-caption text-gray-600"
            v-if="minAmountToOrder(market, currencySymbol) != '--'"
          >
            {{ $t("family.market.showcase.min_order") }}
            <strong>{{ minAmountToOrder(market, currencySymbol) }}</strong>
          </div>
        </CCol>
      </CRow>

      <div v-else class="loading text-center">
        <CSpinner color="primary" size="lg" />
      </div>

      <CCard v-if="market" class="market-showcase-filterbox shadow-sm">
        <CCardBody class="pt-1 pb-2">
          <CRow>
            <CCol xl="8" sm="12">
              <MarketShowcaseFilters
                :viewType.sync="filter.viewType"
                :search.sync="filter.search"
                :producerId.sync="filter.producerId"
                :producerOptions="filter.producerOptions"
                :categoryId.sync="filter.categoryId"
                :categoryOptions="filter.categoryOptions"
                :certificationsIds.sync="filter.certificationsIds"
                :certificationsOptions="filter.certificationsOptions"
                @onSearch="applyFilter"
              />
            </CCol>
            <CCol
              xl="4"
              sm="12"
              class="d-flex justify-content-end align-items-center"
            >
              <CButton
                color="primary"
                variant="outline"
                type="submit"
                class="mr-2"
                :disabled="!hasLastOrder"
                @click="showLastOrder()"
              >
                <font-awesome-icon
                  icon="folder-open"
                  class="mr-2"
                  v-if="!lastOrderLoading"
                />
                <CSpinner
                  v-if="lastOrderLoading"
                  color="primary"
                  size="sm"
                  class="mr-2"
                />

                <span>Letzte Bestellung</span>
              </CButton>
              <CButton
                color="primary"
                type="submit"
                class="mr-2"
                v-if="filter.viewType === 'table'"
                @click="logAllQuantities()"
                variant="outline"
              >
                <font-awesome-icon icon="layer-group" />
                <font-awesome-icon icon="plus" class="ml-2" />
              </CButton>
              <MarketCartButton />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      <CCard v-if="market">
        <CCardBody>
          <MarketShowcaseGrid
            v-show="filter.viewType === 'grid'"
            :filter="filter"
            :bus="bus"
            @onSearch="applyFilter"
          />
          <MarketShowcaseTable
            v-show="filter.viewType === 'table'"
            :filter="filter"
            :bus="bus"
            @onSearch="applyFilter"
            ref="marketTable"
          />
        </CCardBody>
      </CCard>
      <MarketLastOrderModal
        :show.sync="showLastOrderModal"
        :order="lastOrder"
        :familyId="this.$store.state.connections.current.family.id"
        :marketId="this.market.market.id"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import {
  MarketCartButton,
  MarketShowcaseFilters,
  MarketShowcaseGrid,
  MarketShowcaseTable,
  MarketDeliveryMapModal,
} from "./partials";
import get from "lodash/get";
import {
  getCertificationsOptions,
  getMarketCategoryTree,
  getMarketProducersOptions,
} from "../../helpers/options";
import marketMixin from "../../mixins/market";
import { apiGetRQL, apiGet } from "../../helpers/apiHelper";
import MarketLastOrderModal from "./partials/MarketLastOrderModal.vue";

export default {
  name: "UiMarketShowcase",

  mixins: [marketMixin],

  components: {
    MarketCartButton,
    MarketShowcaseFilters,
    MarketShowcaseGrid,
    MarketShowcaseTable,
    MarketDeliveryMapModal,
    MarketLastOrderModal,
  },

  data() {
    return {
      initialized: false,
      currentPage: 1,
      bus: new Vue(),
      showMarketDeliveryMap: false,
      showLastOrderModal: false,
      filter: {
        viewType: "table", // grid | table
        search: "",
        producerId: null,
        producerOptions: [],
        categoryId: null,
        categoryOptions: [],
        certificationsIds: [],
        certificationsOptions: [],
      },
      lastOrder: {
        details: [],
      },
      hasLastOrder: false,
      lastOrderLoading: true,
    };
  },
  computed: {
    haveNestedChildRoute() {
      const { productId, producerId } = this.$route.params;
      return (
        (productId && !isNaN(parseInt(productId, 10))) ||
        (producerId && !isNaN(parseInt(producerId, 10)))
      );
    },

    showNestedChildRoute() {
      const { productId, producerId } = this.$route.params;
      return (
        ((productId && !isNaN(parseInt(productId, 10))) ||
          (producerId && !isNaN(parseInt(producerId, 10)))) &&
        this.initialized
      );
    },

    user_lang() {
      return this.$i18n.locale;
    },

    ...mapState("shop", ["market"]),

    ...mapGetters("connections", ["currencySymbol", "familyId"]),
  },

  mounted() {
    this.init();
    this.setViewTypeBasedOnScreen();
    window.addEventListener("resize", this.setViewTypeBasedOnScreen);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setViewTypeBasedOnScreen);
  },

  watch: {
    $route: "init",
    user_lang(new_lang, old_lang) {
      if (new_lang != old_lang) {
        this.filter.categoryOptions = [];
        this.loadOptions();
      }
    },
  },

  methods: {
    init() {
      const self = this;
      self.initialized = false;
      this.loadMarketData().then(() => {
        self.initialized = true;
        self.LoadExistingCart();
        if (!self.haveNestedChildRoute) {
          self.loadOptions();
        }
      });
    },

    setViewTypeBasedOnScreen() {
      this.filter.viewType = window.innerWidth < 768 ? "grid" : "table";
    },

    async loadMarketData() {
      const self = this;

      const marketId = get(self.market, "market.id", null);

      if (marketId != self.$route.params.marketId) {
        let params = {
          endpoint: "family_markets",
          params: [this.familyId],
          filter: {
            market_id: {
              style: "query",
              operator: "=",
              term: self.$route.params.marketId,
            },
          },
        };

        const response = await apiGetRQL(params);

        if (response && response.data) {
          const marketData = response.data.payload[0];
          self.$store.commit("shop/setMarket", marketData);
        }
      } else {
        return self.market;
      }
    },

    loadOptions() {
      const self = this;
      const lang = this.$i18n.locale;
      const familyId = this.$store.state.connections.current.family.id;
      const marketId = this.market.market.id;

      getMarketCategoryTree({
        lang,
        familyId,
        marketId,
      }).then((options) => {
        self.filter.categoryOptions = [
          { value: null, label: "- " + self.$t("common.all") + " -" },
          ...options,
        ];
      });
      getMarketProducersOptions({
        lang,
        familyId,
        marketId,
      }).then((options) => {
        self.filter.producerOptions = [
          { value: null, label: "- " + self.$t("common.all") + " -" },
          ...options,
        ];
      });
      getCertificationsOptions().then((options) => {
        self.filter.certificationsOptions = [...options];
      });
    },

    applyFilter({ filter }) {
      this.bus.$emit("onSearch", filter);
    },

    onBack() {
      const familyId = this.$store.state.connections.current.family.id;
      this.$router.push({ name: "UserMarketList", params: { id: familyId } });
    },

    LoadExistingCart() {
      this.$store.dispatch("shop/loadCart");
    },

    logAllQuantities() {
      this.$refs.marketTable?.logQuantities();
    },

    // Get the last order and populate the cart with the same products and quantities
    async fetchLastOrder() {
      const response = await apiGet("role_order_family", [
        this.$store.state.connections.current.family.id,
      ]);
      if (response && response.data) {
        const orders = response.data.payload.Items;
        const currentMarketId = get(this.market, "market.id", null);

        // Find the last order matching the current market
        const matchingOrders = orders.filter(
          (order) => get(order, "market.id") == currentMarketId
        );

        if (matchingOrders.length === 0) {
          this.lastOrder = null;
          this.hasLastOrder = false;
          this.lastOrderLoading = false;
          return;
        }

        this.lastOrder = matchingOrders[0]; // Assuming orders are sorted by date

        // Fetch order details
        const detailsResponse = await apiGet("role_order_family_details", [
          this.$store.state.connections.current.family.id,
          this.lastOrder.id,
        ]);

        if (detailsResponse && detailsResponse.data) {
          this.lastOrder.details = detailsResponse.data.payload.Items;
          this.hasLastOrder = true;
          this.lastOrderLoading = false;
        }
      }
    },

    showLastOrder() {
      this.showLastOrderModal = true;
    },
  },

  created() {
    this.fetchLastOrder();
  },
};
</script>
